import { Directive, Input, inject } from '@angular/core';
import { ShellStore } from '@partners/state';

@Directive({
  selector: '[fixedFooterToggle]',
  standalone: true
})
export class FixedFooterToggleDirective {
  @Input()
  set fixedFooterToggle(isFooterFixed: boolean) {
    this._shellStore.dispatchUpdateShellView({ isFooterFixed });
  }

  private _shellStore = inject(ShellStore);

  constructor() {}
}
